import { render, staticRenderFns } from "./resetdialog.vue?vue&type=template&id=2164dfda&scoped=true"
import script from "./resetdialog.vue?vue&type=script&lang=js"
export * from "./resetdialog.vue?vue&type=script&lang=js"
import style0 from "./resetdialog.vue?vue&type=style&index=0&id=2164dfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164dfda",
  null
  
)

export default component.exports